import { render, staticRenderFns } from "./donationCard.vue?vue&type=template&id=73958ab0&scoped=true&"
import script from "./donationCard.vue?vue&type=script&lang=js&"
export * from "./donationCard.vue?vue&type=script&lang=js&"
import style0 from "./donationCard.vue?vue&type=style&index=0&id=73958ab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73958ab0",
  null
  
)

export default component.exports